var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.785 12.614h-21.57c-6.96 0-12.601 5.642-12.601 12.602v21.568c0 6.96 5.642 12.602 12.602 12.602h21.568c6.96 0 12.602-5.642 12.602-12.602V25.216c0-6.96-5.642-12.602-12.602-12.602z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M46.785 12.614h-21.57c-6.96 0-12.601 5.642-12.601 12.602v21.568c0 6.96 5.642 12.602 12.602 12.602h21.568c6.96 0 12.602-5.642 12.602-12.602V25.216c0-6.96-5.642-12.602-12.602-12.602z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 11.29,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.709,
    cy: 22.291,
    r: 2.419
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.83f157c5eafbfa958b718ddbef8d34c1.svg";
export { ForwardRef as ReactComponent };